import { fromDroppoints } from 'maps/services/dto/fromDroppoint'
import type { DataFromDroppoint, Location, Store } from 'maps/types'
import { ENDPOINT_DROPPOINTS } from 'maps/utils/constants'
import { fetcher } from 'services/rest/fetcher'
import { env } from 'utils/envManager'
import { url } from 'utils/url'

interface GetDroppointsProps {
	address: string
	cityName: string
	countryISO: string
	postalCode: string
}

const getDroppoints = async ({
	address,
	cityName,
	countryISO,
	postalCode,
}: GetDroppointsProps): Promise<Store[] | null> => {
	try {
		const endpoint = url(
			`${env.NEXT_PUBLIC_SITE_BASE_URL}/${ENDPOINT_DROPPOINTS}/${countryISO.toLowerCase()}/droppoints`,
			{
				channel: env.NEXT_PUBLIC_CHANNEL,
				address,
				cityName,
				postalCode,
			}
		)

		const { droppoints } = await fetcher<{ droppoints: DataFromDroppoint[] }>(
			endpoint
		)
		return droppoints.map(fromDroppoints)
	} catch (error) {
		console.error(`[Maps] Error fetching droppoints: ${error}`)
	}

	return null
}

export const getDroppointsData = async (
	location: Location,
	countryISO: string
) => {
	const {
		address = '',
		cityName = '',
		postalCode = '',
	} = location?.addressInfo ?? {}
	return (
		(await getDroppoints({
			address,
			cityName,
			postalCode,
			countryISO,
		})) ?? []
	)
}
